import React from 'react';
import {BrowserRouter as Router, Routes, Route, useLocation, useNavigate} from 'react-router-dom';

import "./App.css"
import {Typography, Link} from "@mui/joy";
import TOS from "./Components/Public/TOS";
import PrivacyPolicy from "./Components/Public/PrivacyPolicy";

import PersQuizPage from './Components/Published/PersQuizPage';
import PersQuizGen from './Components/Generator/PersQuizGen';
import PollPage from "./Components/Published/PollPage";
import PollGen from "./Components/Generator/PollGen";
import QuizPage from "./Components/Published/QuizPage";
import QuizGen from "./Components/Generator/QuizGen";

const Header = () => {
    const navigate = useNavigate();

    return (
        <header>
            <div style={{display: "flex", flexDirection: "row", alignItems: "center", gap: "20px", marginLeft: "20px", marginTop: "20px", marginRight: "20px"}}>
                <img onClick={() => navigate("/")} src={"/cdn/logo/logo-black.svg"} alt={""} height={"60px"} style={{cursor: "pointer", marginLeft: "10px"}}/>
                <Typography level={"body-lg"} onClick={() => navigate("/generate/poll")} style={{cursor: "pointer", marginLeft: "10px"}}>Poll</Typography>
                <Typography level={"body-lg"} onClick={() => navigate("/generate/quiz")} style={{cursor: "pointer", marginLeft: "10px"}}>Quiz</Typography>
                <Typography level={"body-lg"} onClick={() => navigate("/generate/perquiz")} style={{cursor: "pointer", marginLeft: "10px"}}>Personality Quiz</Typography>
            </div>
        </header>
    );
};
const Footer = () =>
    <footer>
        <div style={{marginLeft: "20px", marginRight: "20px", display: "flex", flexDirection: "row", alignItems: "center", gap: "20px"}}>
            <Typography>©2025 Nualaiochta Consulting, LLC</Typography>
            <Link href={"https://www.superfroggie.com"}>A SuperFroggie App</Link>
            <Link href={"/legal/tos"}>Terms of Service</Link>
            <Link href={"/legal/privacy"}>Privacy Policy</Link>
        </div>
    </footer>;

const Layout = ({ children }) => {
    const location = useLocation();
    const isPublishedRoute = location.pathname.startsWith('/published');

    return (
        <>
            {!isPublishedRoute && <Header />}
            <main>{children}</main>
            {!isPublishedRoute && <Footer />}
        </>
    );
};

function App() {
    return (
        <Router>
            <Layout>
                <Routes>
                    <Route path="/published/perquiz/:siteUrl" element={<PersQuizPage />} />
                    <Route path="/generate/perquiz" element={<PersQuizGen />} />
                    <Route path="/published/poll/:pollDataUrl" element={<PollPage />} />
                    <Route path="/generate/poll" element={<PollGen />} />
                    <Route path="/published/quiz/:quizDataUrl" element={<QuizPage />} />
                    <Route path="/generate/quiz" element={<QuizGen />} />
                    <Route path="/legal/tos" element={<TOS />} />
                    <Route path="/legal/privacy" element={<PrivacyPolicy />} />
                </Routes>
            </Layout>
        </Router>
    );
}

export default App;